import fetch from "../components/optionsFetch";
﻿/* eslint-disable no-restricted-globals */
import * as React from 'react';
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from '@progress/kendo-react-inputs';
import { Reports } from "./ReportData";
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import  ReportViewer  from '../components/ReportViewer';
import configData from "../config.json";
import { GetSession, GetToken, GetUserName } from '../components/Session';
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { GetPermissions } from '../components/Options';
import { GetCloudLogin } from "../WeighBridge/Helpers";
import { useNavigate } from "react-router-dom";
import { filterBy } from "@progress/kendo-data-query";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";
import "./SimpleReports.scss";

const SimpleReports = () => {
    const navigate = useNavigate()
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const [permissions, setPermissions] = React.useState(null);
    const [company, setCompany] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [url, setUrl] = React.useState(configData.SERVER_URL);
    const [token, setToken] = React.useState(GetToken());
    const [showDates, setShowDates] = React.useState(true);
    const [showOptions, setShowOptions] = React.useState(false);
    const [allReports, setAllReports] = React.useState(Reports);
    const [siteName, setSiteName] = React.useState("");
    const [activeSites, setActiveSites] = React.useState("All Sites");
    const [activeSitesSum, setActiveSitesSum] = React.useState("All Sites");
    const [activeCust, setActiveCust] = React.useState("All Customers");
    const [activeCustSum, setActiveCustSum] = React.useState("All Customers");
    const [activeCustProd, setActiveCustProd] = React.useState("All Products");
    const [activeCustCust, setActiveCustCust] = React.useState("All Customers");
    const [activeSupp, setActiveSupp] = React.useState("All Suppliers");
    const [activeSuppSum, setActiveSuppSum] = React.useState("All Suppliers");
    const [activeCat, setActiveCat] = React.useState("All Waste Streams");
    const [activeCatSum, setActiveCatSum] = React.useState("All Waste Streams");
    const [activeSrc, setActiveSrc] = React.useState("All Sources");
    const [activeSrcSum, setActiveSrcSum] = React.useState("All Sources");
    const [activeDest, setActiveDest] = React.useState("All Destinations");
    const [activeDestSum, setActiveDestSum] = React.useState("All Destinations");
    const [activeProd, setActiveProd] = React.useState("All Products");
    const [activeProdSum, setActiveProdSum] = React.useState("All Products");
    const [activePProd, setActivePProd] = React.useState("All Products");
    const [activePDest, setActivePDest] = React.useState("All Destinations");
    const [activeCount, setActiveCounted] = React.useState("All Counted Items");
    const [activeCountedSum, setActiveCountedSum] = React.useState("All Counted Items");
    const [activeType, setActiveType] = React.useState("All Vehicle Types");
    const [activeTypeSum, setActiveTypeSum] = React.useState("All Vehicle Types");
    const [activeJob, setActiveJob] = React.useState("All Jobs");
    const [activeJobSum, setActiveJobSum] = React.useState("All Jobs");
    const [activeJJobs, setActiveJJobs] = React.useState("All Jobs");
    const [activeJProd, setActiveJProd] = React.useState("All Products");
    const [activeMJobs, setActiveMJobs] = React.useState("All Jobs");
    const [activeUser, setActiveUser] = React.useState("All Operators");
    const [activeUserSum, setActiveUserSum] = React.useState("All Operators");
    const [activeOJob, setActiveOJob] = React.useState("All Jobs");
    const [dialogError, setDialogError] = React.useState("");

    React.useEffect(() => {
        AddCustomReports();
        GetCloudLogin((cred) => {
            var baseUrl = configData.SERVER_URL;
            var token = GetToken();
            if (cred.token !== undefined && cred.token !== null && cred.token !== "") {
                baseUrl = GetSession().CloudURL;
                token = cred.token;
                setUrl(baseUrl);
                setToken(token);
            }
            var url = `${baseUrl}apiv7/sites?$filter=siteid eq 1 &search=ouiewq`;
            const init = {
                method: 'GET',
                accept: 'application/json',
                headers: { "Authorization": "Bearer " + token }
            }
            fetch(url, init).then(response => response.json()).then(d => {
                if (d !== undefined && d.length > 0) {
                    setCompany(d[0]['address1']);
                    setAddress(d[0]['address2']);
                }
            });
            url = `${baseUrl}apiv7/options`;
            fetch(url, init).then(response => response.json()).then(opt => {
                var sites = opt.sites;
                setSitesData(sites);
                setSiteValue(sites);
            });
        });
        GetPermissions(["ViewSettings"], setPermissions);
    }, []);

    const initialExpanded = Reports.reduce(
        (acc, cur) => ({
            ...acc,
            [cur.id]: false,
        }),
        {}
    );   
    const [expanded, setExpanded] = React.useState({
        ...initialExpanded,
        Brazil: true,
    });
    const onAction = React.useCallback(
        (id) => {
            setExpanded({
                ...expanded,
                [id]: !expanded[id],
            });
        },
        [expanded]
    );
    let dr;
    let dt = new Date();
    dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()) };
    //localStorage.setItem("ReportDates", JSON.stringify(dr));
    
    const [dateRange, setDateRange] = React.useState(dr);
    const [reportSelected, setReportSelected] = React.useState();
    const [reportName, setReportName] = React.useState();
    const [sitesData, setSitesData] = React.useState([]);
    const [loadTypeData, setLoadTypeData] = React.useState([]);
    const [directionData, setDirectionData] = React.useState([]);
    const [paymentData, setPaymentData] = React.useState([]);
    const [chargeData, setChargeData] = React.useState([]);
    const [vehicleData, setVehicleData] = React.useState([]);
    const [showDateRange, setShowDateRange] = React.useState(false);
    const rangeChanged = (event) => {
        const newRange = event.value;

        setDateRange(newRange);

        if (newRange.start && newRange.end) {
            setShowDateRange(false);
        }
    };

    const GenerateReport = (report) => {
        setReportSelected(report);
        DateSearch(report);
    }
    
    const [siteValue, setSiteValue] = React.useState([]);
    const onSiteChanged = (event) => { setSiteValue([...event.value]); };
    const [loadTypeValue, setLoadTypeValue] = React.useState([]);
    const onLoadTypeChanged = (event) => { setLoadTypeValue([...event.value]); };
    const [paymentValue, setPaymentValue] = React.useState([]);
    const onPaymentChanged = (event) => { setPaymentValue([...event.value]); };
    const [directionValue, setDirectionValue] = React.useState([]);
    const onDirectionChanged = (event) => { setDirectionValue([...event.value]); };
    const [vehicleValue, setVehicleValue] = React.useState([]);
    const onVehicleChanged = (event) => { setVehicleValue([...event.value]); };
    const [chargeValue, setChargeValue] = React.useState([]);
    const onChargeChanged = (event) => { setChargeValue([...event.value]); };
    const [productData, setProductData] = React.useState(null);
    const [customerData, setCustomerData] = React.useState(null);
    const [jobData, setJobData] = React.useState(null);
    const [categories, setCategories] = React.useState(null);
    const [sourceData, setSourceData] = React.useState(null);
    const [destData, setDestData] = React.useState(null);
    const [vcData, setVcData] = React.useState(null);
    const [truckData, setTruckData] = React.useState(null);
    const [userData, setUserData] = React.useState(null);

    const DateSearch = (report) => {
        let sd = dateRange.start === null ? new Date().toISOString() : dateRange.start.toISOString();
        let ed = dateRange.end === null ? new Date().toISOString() : dateRange.end.toISOString();
        let sites = "";
        if (siteValue !== undefined) {
            siteValue.forEach(x => sites += (sites !== "" ? "," : "") + x.id);
        }
        let act1 = GetActive(report, false, false);
        let inact1 = GetActive(report, true, false);
        let act2 = GetActive(report, false, true);
        let inact2 = GetActive(report, true, true);
        var url = `${configData.SERVER_URL}apiv7/transactionreports/gettransactionoptions?startdate=${sd}&enddate=${ed}&sites=${sites}&report=${report}&showactive=${act1}&showinactive=${inact1}&showactive2=${act2}&showinactive2=${inact2}`;
        const init = {
            method: 'GET',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response.json()).then(l => {
            if (l.count === 0) {
                setDialogError("There are no records for the selected date range");
            } else {
                setShowDates(false);
                setShowOptions(true);
                setChargeData(l.chargeTypes);
                setChargeValue(l.chargeTypes);
                setDirectionData(l.directions);
                setDirectionValue(l.directions);
                setPaymentData(l.paymentMethods);
                setPaymentValue(l.paymentMethods);
                setLoadTypeData(l.loadTypes);
                setLoadTypeValue(l.loadTypes);
                setVehicleData(l.vehicleTypes);
                setVehicleValue(l.vehicleTypes);
                setShowDates(false);
                setCustomerData(l.customers);
                setProductData(l.products);
                setJobData(l.jobs);
                setSourceData(l.sources);
                setDestData(l.destinations);
                setVcData(l.vehicleConfigurations);
                setTruckData(l.vehicles);
                setUserData(l.users);
                setCategories(l.productCategories);
                ConfigureProducts(l.products);
                ConfigureCustomers(l.customers);
                ConfigureJobs(l.jobs);
                ConfigureSources(l.sources);
                ConfigureDestinations(l.destinations);
                ConfigureUsers(l.users);
                ConfigureCategorys(l.productCategories);
                Configuretrucks(l.vehicles);
                Configurevcs(l.vehicleConfigurations);
            }
        });
    }

    const Restart = () => {
        setReportName("");
        setShowDates(true);
        setShowOptions(false);
    }

    const ShowReport = () => {
        // for all entities that are empty, select all the available values. If left empty, all will be used (active and inactive) even though only some selected
        if (siteName !== "" && reportSelected === "Custom")
            setReportName(siteName + reportSelected);
        else
            setReportName(reportSelected);
    }

    const AddCustomReports = () => {
        let username = GetUserName();
        let sp = username.split('.');
        switch (sp[0]) {
            case "wagga":
                setAllReports([{
                    id: "Custom",
                    report: "Custom",
                }, ...Reports]);
                setSiteName("wagga_");
                break;
        }
    }

    const GetActive = (report, inact, second) => {
        switch (report) {
            case "TransactionBySite":
                if (inact) {
                    return activeSites === "All Sites" || activeSites === "Inactive Sites";
                } else {
                    return activeSites === "All Sites" || activeSites === "Active Sites";
                }
                break;
            case "TransactionBySiteSummary":
                if (inact) {
                    return activeSitesSum === "All Sites" || activeSitesSum === "Inactive Sites";
                } else {
                    return activeSitesSum === "All Sites" || activeSitesSum === "Active Sites";
                }
                break;
            case "TransactionByCustomer":
                if (inact) {
                    return activeCust === "All Customers" || activeCust === "Inactive Customers";
                } else {
                    return activeCust === "All Customers" || activeCust === "Active Customers";
                }
                break;
            case "TransactionByCustomerSummary":
                if (inact) {
                    return activeCustSum === "All Customers" || activeCustSum === "Inactive Customers";
                } else {
                    return activeCustSum === "All Customers" || activeCustSum === "Active Customers";
                }
                break;
            case "TransactionByProductCustomerSummary":
                if (second) {
                    if (inact) {
                        return activeCustProd === "All Products" || activeCustProd === "Inactive Products";
                    } else {
                        return activeCustProd === "All Products" || activeCustProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activeCustCust === "All Customers" || activeCustCust === "Inactive Customers";
                    } else {
                        return activeCustCust === "All Customers" || activeCustCust === "Active Customers";
                    }
                }
                break;
            case "TransactionBySupplier":
                if (inact) {
                    return activeSupp === "All Suppliers" || activeSupp === "Inactive Suppliers";
                } else {
                    return activeSupp === "All Suppliers" || activeSupp === "Active Suppliers";
                }
                break;
            case "TransactionBySupplierSummary":
                if (inact) {
                    return activeSuppSum === "All Suppliers" || activeSuppSum === "Inactive Suppliers";
                } else {
                    return activeSuppSum === "All Suppliers" || activeSuppSum === "Active Suppliers";
                }
                break;
            case "TransactionByWasteStream":
                if (inact) {
                    return activeCat === "All Waste Streams" || activeCat === "Inactive Waste Streams";
                } else {
                    return activeCat === "All Waste Streams" || activeCat === "Active Waste Streams";
                }
                break;
            case "TransactionByWasteStreamSummary":
                if (inact) {
                    return activeCatSum === "All Waste Streams" || activeCatSum === "Inactive Waste Streams";
                } else {
                    return activeCatSum === "All Waste Streams" || activeCatSum === "Active Waste Streams";
                }
                break;
                break;
            case "TransactionBySource":
                if (inact) {
                    return activeSrc === "All Sources" || activeSrc === "Inactive Sources";
                } else {
                    return activeSrc === "All Sources" || activeSrc === "Active Sources";
                }
                break;
            case "TransactionBySourceSummary":
                if (inact) {
                    return activeSrcSum === "All Sources" || activeSrcSum === "Inactive Sources";
                } else {
                    return activeSrcSum === "All Sources" || activeSrcSum === "Active Sources";
                }
                break;
            case "TransactionByDestination":
                if (inact) {
                    return activeDest === "All Destinations" || activeDest === "Inactive Destinations";
                } else {
                    return activeDest === "All Destinations" || activeDest === "Active Destinations";
                }
                break;
            case "TransactionByDestinationSummary":
                if (inact) {
                    return activeDestSum === "All Destinations" || activeDestSum === "Inactive Destinations";
                } else {
                    return activeDestSum === "All Destinations" || activeDestSum === "Active Destinations";
                }
                break;
            case "TransactionByProduct":
                if (inact) {
                    return activeProd === "All Products" || activeProd === "Inactive Products";
                } else {
                    return activeProd === "All Products" || activeProd === "Active Products";
                }
                break;
            case "TransactionByProductSummary":
                if (inact) {
                    return activeProdSum === "All Products" || activeProdSum === "Inactive Products";
                } else {
                    return activeProdSum === "All Products" || activeProdSum === "Active Products";
                }
                break;
            case "TransactionByDestinationByProductSummary":
                if (second) {
                    if (inact) {
                        return activePProd === "All Products" || activePProd === "Inactive Products";
                    } else {
                        return activePProd === "All Products" || activePProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activePDest === "All Destinations" || activePDest === "Inactive Destinations";
                    } else {
                        return activePDest === "All Destinations" || activePDest === "Active Destinations";
                    }
                }
                break;
            case "TransactionByCountedProduct":
                if (inact) {
                    return activeCount === "All Counted Items" || activeCount === "Inactive Counted Items";
                } else {
                    return activeCount === "All Counted Items" || activeCount === "Active Counted Items";
                }
                break;
            case "TransactionByCountedProductSummary":
                if (inact) {
                    return activeCountedSum === "All Counted Items" || activeCountedSum === "Inactive Counted Items";
                } else {
                    return activeCountedSum === "All Counted Items" || activeCountedSum === "Active Counted Items";
                }
                break;
            case "TransactionByVehicleType":
                if (inact) {
                    return activeType === "All Vehicle Types" || activeType === "Inactive Vehicle Types";
                } else {
                    return activeType === "All Vehicle Types" || activeType === "Active Vehicle Types";
                }
                break;
            case "TransactionByVehicleTypeSummary":
                if (inact) {
                    return activeTypeSum === "All Vehicle Types" || activeTypeSum === "Inactive Vehicle Types";
                } else {
                    return activeTypeSum === "All Vehicle Types" || activeTypeSum === "Active Vehicle Types";
                }
                break;
            case "TransactionByJob":
                if (inact) {
                    return activeJob === "All Jobs" || activeJob === "Inactive Jobs";
                } else {
                    return activeJob === "All Jobs" || activeJob === "Active Jobs";
                }
                break;
            case "TransactionByJobSummary":
                if (inact) {
                    return activeJobSum === "All Jobs" || activeJobSum === "Inactive Jobs";
                } else {
                    return activeJobSum === "All Jobs" || activeJobSum === "Active Jobs";
                }
                break;
            case "TransactionByProductJobSummary":
                if (second) {
                    if (inact) {
                        return activeJProd === "All Products" || activeJProd === "Inactive Products";
                    } else {
                        return activeJProd === "All Products" || activeJProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activeJJobs === "All Jobs" || activeJJobs === "Inactive Jobs";
                    } else {
                        return activeJJobs === "All Jobs" || activeJJobs === "Active Jobs";
                    }
                }
                break;
            case "TransactionByJobByLoad":
                if (inact) {
                    return activeMJobs === "All Jobs" || activeMJobs === "Inactive Jobs";
                } else {
                    return activeMJobs === "All Jobs" || activeMJobs === "Active Jobs";
                }
                break;
            case "TransactionByOperator":
                if (inact) {
                    return activeUser === "All Operators" || activeUser === "Inactive Operators";
                } else {
                    return activeUser === "All Operators" || activeUser === "Active Operators";
                }
                break;
            case "TransactionByOperatorSummary":
                if (inact) {
                    return activeUserSum === "All Operators" || activeUserSum === "Inactive Operators";
                } else {
                    return activeUserSum === "All Operators" || activeUserSum === "Active Operators";
                }
                break;
            case "TransactionByOverweightJob":
                if (inact) {
                    return activeOJob === "All Jobs" || activeOJob === "Inactive Jobs";
                } else {
                    return activeOJob === "All Jobs" || activeOJob === "Active Jobs";
                }
                break;
        }
        return false;
    }

    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const textField = "text";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };

    const GetConfigData = (act) => {
        let sl = [];
        let selected = [];
        if (act === null) return { active: { id: 0, text: 'All', items: sl }, selected: selected };
        for (let i = 0; i < act.length; i++) {
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            selected.push(entry);
        }
        let active = { id: 0, text: 'All', items: sl };
        return { active: active, selected: selected };
    }

    // state data for PRODUCT multi-select tree   
    const [productsData, setProductsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [productsValue, setProductsValue] = React.useState([]);
    const [productExpanded, setProductExpanded] = React.useState([]);
    const onProductsChange = (event) => {
        setProductsValue(getMultiSelectTreeValue(productsData, { ...fields, ...event, value: productsValue, }));
    }
    const onProductsExpandChange = React.useCallback((event) => setProductExpanded(expandedState(event.item, dataItemKey, productExpanded)), [productExpanded]);
    const productsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(productsData, { expanded: productExpanded, value: productsValue, ...fields }), [productsData, productExpanded, productsValue]
    );
    const ConfigureProducts = (act) => {
        if (act === null) setProductsValue([]);
        let x = GetConfigData(act);
        setProductsData([x.active]);
        return [];
    }
    const ProductChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setProductsValue(v);
    };

    // state data for JOB multi-select tree   
    const [jobsData, setJobsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [jobsValue, setJobsValue] = React.useState([]);
    const [jobExpanded, setJobExpanded] = React.useState([]);
    const onJobsChange = (event) => {
        setJobsValue(getMultiSelectTreeValue(jobsData, { ...fields, ...event, value: jobsValue, }));
    }
    const onjobsExpandChange = React.useCallback((event) => setJobExpanded(expandedState(event.item, dataItemKey, jobExpanded)), [jobExpanded]);
    const jobsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(jobsData, { expanded: jobExpanded, value: jobsValue, ...fields }), [jobsData, jobExpanded, jobsValue]
    );
    const ConfigureJobs = (act) => {
        if (act === null) setJobsValue([]);
        let x = GetConfigData(act);
        setJobsData([x.active]);
        return [];
    }
    const JobChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setJobsValue(v);
    };

    // state data for CUSTOMER multi-select tree   
    const [customersData, setCustomersData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [customersValue, setCustomersValue] = React.useState([]);
    const [customerExpanded, setCustomerExpanded] = React.useState([]);
    const onCustomersChange = (event) => {
        setCustomersValue(getMultiSelectTreeValue(customersData, { ...fields, ...event, value: customersValue, }));
    }
    const oncustomersExpandChange = React.useCallback((event) => setCustomerExpanded(expandedState(event.item, dataItemKey, customerExpanded)), [customerExpanded]);
    const customersTreeData = React.useMemo(() =>
        processMultiSelectTreeData(customersData, { expanded: customerExpanded, value: customersValue, ...fields }), [customersData, customerExpanded, customersValue]
    );
    const ConfigureCustomers = (act) => {
        if (act === null) setCustomersValue([]);
        let x = GetConfigData(act);
        setCustomersData([x.active]);
        return [];
    }
    const CustomerChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setCustomersValue(v);
    };

    // state data for source multi-select tree   
    const [sourcesData, setSourcesData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, { ...fields, ...event, value: sourcesValue, }));
    }
    const onsourcesExpandChange = React.useCallback((event) => setSourceExpanded(expandedState(event.item, dataItemKey, sourceExpanded)), [sourceExpanded]);
    const sourcesTreeData = React.useMemo(() =>
        processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourcesData, sourceExpanded, sourcesValue]
    );
    const ConfigureSources = (act) => {
        if (act === null) setSourcesValue([]);
        let x = GetConfigData(act);
        setSourcesData([x.active]);
        return [];
    }
    const SourceChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setSourcesValue(v);
    };

    // state data for destination multi-select tree   
    const [destinationsData, setDestinationsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [destinationsValue, setDestinationsValue] = React.useState([]);
    const [destinationExpanded, setDestinationExpanded] = React.useState([]);
    const onDestinationsChange = (event) => {
        setDestinationsValue(getMultiSelectTreeValue(destinationsData, { ...fields, ...event, value: destinationsValue, }));
    }
    const ondestinationsExpandChange = React.useCallback((event) => setDestinationExpanded(expandedState(event.item, dataItemKey, destinationExpanded)), [destinationExpanded]);
    const destinationsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(destinationsData, { expanded: destinationExpanded, value: destinationsValue, ...fields }), [destinationsData, destinationExpanded, destinationsValue]
    );
    const ConfigureDestinations = (act) => {
        if (act === null) setDestinationsValue([]);
        let x = GetConfigData(act);
        setDestinationsData([x.active]);
        return [];
    }
    const DestinationChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setDestinationsValue(v);
    };

    // state data for User multi-select tree   
    const [usersData, setUsersData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [usersValue, setUsersValue] = React.useState([]);
    const [userExpanded, setUserExpanded] = React.useState([]);
    const onUsersChange = (event) => {
        setUsersValue(getMultiSelectTreeValue(usersData, { ...fields, ...event, value: usersValue, }));
    }
    const onUsersExpandChange = React.useCallback((event) => setUserExpanded(expandedState(event.item, dataItemKey, userExpanded)), [userExpanded]);
    const usersTreeData = React.useMemo(() =>
        processMultiSelectTreeData(usersData, { expanded: userExpanded, value: usersValue, ...fields }), [usersData, userExpanded, usersValue]
    );
    const ConfigureUsers = (act) => {
        if (act === null) setUsersValue([]);
        let x = GetConfigData(act);
        setUsersData([x.active]);
        return [];
    }
    const UserChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setUsersValue(v);
    };

    // state data for category multi-select tree   
    const [categoryData, setCategoryData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [categoryValues, setCategoryValues] = React.useState([]);
    const [categoryExpanded, setCategoryExpanded] = React.useState([]);
    const onCategoryChange = (event) => {
        setCategoryValues(getMultiSelectTreeValue(categoryData, { ...fields, ...event, value: categoryValues, }));
    }
    const onCategoryExpandChange = React.useCallback((event) => setCategoryExpanded(expandedState(event.item, dataItemKey, categoryExpanded)), [categoryExpanded]);
    const categoryTreeData = React.useMemo(() =>
        processMultiSelectTreeData(categoryData, { expanded: categoryExpanded, value: categoryValues, ...fields }), [categoryData, categoryExpanded, categoryValues]
    );
    const ConfigureCategorys = (act) => {
        if (act === null) setCategoryValues([]);
        let x = GetConfigData(act);
        setCategoryData([x.active]);
        return [];
    }
    const CategoryChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setCategoryValues(v);
    };

    // state data for vc multi-select tree   
    const [vcsData, setvcsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [vcsValue, setvcsValue] = React.useState([]);
    const [vcExpanded, setvcExpanded] = React.useState([]);
    const onvcsChange = (event) => {
        setvcsValue(getMultiSelectTreeValue(vcsData, { ...fields, ...event, value: vcsValue, }));
    }
    const onvcsExpandChange = React.useCallback((event) => setvcExpanded(expandedState(event.item, dataItemKey, vcExpanded)), [vcExpanded]);
    const vcsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(vcsData, { expanded: vcExpanded, value: vcsValue, ...fields }), [vcsData, vcExpanded, vcsValue]
    );
    const Configurevcs = (act) => {
        if (act === null) setvcsValue([]);
        let x = GetConfigData(act);
        setvcsData([x.active]);
        return [];
    }
    const vcChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setvcsValue(v);
    };

    // state data for truck multi-select tree   
    const [trucksData, settrucksData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [trucksValue, settrucksValue] = React.useState([]);
    const [truckExpanded, settruckExpanded] = React.useState([]);
    const ontrucksChange = (event) => {
        settrucksValue(getMultiSelectTreeValue(trucksData, { ...fields, ...event, value: trucksValue, }));
    }
    const ontrucksExpandChange = React.useCallback((event) => settruckExpanded(expandedState(event.item, dataItemKey, truckExpanded)), [truckExpanded]);
    const trucksTreeData = React.useMemo(() =>
        processMultiSelectTreeData(trucksData, { expanded: truckExpanded, value: trucksValue, ...fields }), [trucksData, truckExpanded, trucksValue]
    );
    const Configuretrucks = (act) => {
        if (act === null) settrucksValue([]);
        let x = GetConfigData(act);
        settrucksData([x.active]);
        return [];
    }
    const truckChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        settrucksValue(v);
    };

    return (
        <div className="simple-reports">
            {!reportName && <div>
                {showDates && <h5 className="report-title">Click One of the Transaction Reports to View</h5>}
                {showDates && <div>
                    <div className="row Reportfillter">
                        <div className="col-md-4">
                            <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}
                                startDateInputSettings={{ label: "Date - Start" }}
                                endDateInputSettings={{ label: "Date - End" }}
                            />
                        </div>
                        <div className='col-md-4'>
                            Site
                            <MultiSelect
                                data={sitesData}
                                onChange={onSiteChanged}
                                value={siteValue}
                                textField="name" dataItemKey="id"
                                placeholder="Please select ..."
                            />
                        </div>
                    </div>
                </div>}
                {showOptions && (
                    <div className="report-options">
                        <section className="report-options__card" aria-labelledby="report-options-title">
                            <header className="report-options__header">
                                <span className="report-options__icon"><i className="fa-solid fa-sliders" aria-hidden="true" /></span>
                                <div>
                                    <h2 id="report-options-title">Report options</h2>
                                    <p>Choose which transactions to include in your report.</p>
                                </div>
                            </header>
                            <div className="row report-options__fields">

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Load Type</label>
                                    <MultiSelect
                                        data={loadTypeData}
                                        onChange={onLoadTypeChanged}
                                        value={loadTypeValue}
                                        placeholder="Select load type..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Payments</label>
                                    <MultiSelect
                                        data={paymentData}
                                        onChange={onPaymentChanged}
                                        value={paymentValue}
                                        placeholder="Select payments..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Direction</label>
                                    <MultiSelect
                                        data={directionData}
                                        onChange={onDirectionChanged}
                                        value={directionValue}
                                        placeholder="Select direction..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Vehicle Type</label>
                                    <MultiSelect
                                        data={vehicleData}
                                        onChange={onVehicleChanged}
                                        value={vehicleValue}
                                        placeholder="Select vehicle type..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Charge Type</label>
                                    <MultiSelect
                                        data={chargeData}
                                        onChange={onChargeChanged}
                                        value={chargeValue}
                                        placeholder="Select charge type..."
                                    />
                                </div>

                                {customerData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">
                                            {String(reportSelected).includes("Supplier")
                                                ? "Suppliers"
                                                : "Customers"}
                                        </label>
                                        <MultiSelectTreeEditor name={"customerId"} data={customersTreeData} value={customersValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={CustomerChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {sourceData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Sources</label>
                                        <MultiSelectTreeEditor name={"Source"} data={sourcesTreeData} value={sourcesValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourceChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {destData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Destinations</label>
                                        <MultiSelectTreeEditor name={"destination"} data={destinationsTreeData} value={destinationsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestinationChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {vcData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Truck Configurations</label>
                                        <MultiSelectTreeEditor name={"vcId"} data={vcsTreeData} value={vcsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={vcChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {truckData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">
                                            {String(reportSelected).includes("Type")
                                                ? "Vehicle Type"
                                                : "Trucks"}
                                        </label>
                                        <MultiSelectTreeEditor name={"truckId"} data={trucksTreeData} value={trucksValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={truckChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {jobData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Jobs</label>
                                        <MultiSelectTreeEditor name={"Job"} data={jobsTreeData} value={jobsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={JobChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {userData && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Users</label>
                                        <MultiSelectTreeEditor name={"userId"} data={usersTreeData} value={usersValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={UserChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {categories && (
                                    <div className="col-md-4 mb-3 MSTree">
                                        <label className="filter-label">Waste Stream</label>
                                        <MultiSelectTreeEditor name={"categoryId"} data={categoryTreeData} value={categoryValues} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={CategoryChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}

                                {productData && productData.length > 0 && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label MSTree">Products</label>
                                        <MultiSelectTreeEditor name={"productId"} data={productsTreeData} value={productsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={ProductChanged} textField="name" dataItemKey="id" />                                
                                    </div>
                                )}
                            </div>

                            <footer className="report-options__actions">
                                <Button className="report-options__back" onClick={Restart}>
                                    <i className="fa-solid fa-arrow-left" aria-hidden="true" /> Back to list
                                </Button>
                                <Button themeColor="primary" onClick={ShowReport}>
                                    <i className="fa-regular fa-file-lines" aria-hidden="true" /> View report
                                </Button>
                            </footer>
                        </section>
                    </div>
                )}
                {showDates && <div className="wrapper">
                    {allReports.map((item) => (
                        <ExpansionPanel
                            title={item.report}
                            expanded={expanded === item.id}
                            tabIndex={0}
                            key={item.id}

                            onAction={(event) => {
                                setExpanded(event.expanded ? "" : item.id);
                            }}
                        >
                            {expanded === "Custom" && item.id === "Custom" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport(item.id)} id={item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ListOfTransactions" && item.id === "ListOfTransactions" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="ReportButton"><Button onClick={() => GenerateReport("TransactionsList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Transaction List</Button>
                                                <Button style={{ marginLeft: "10px" }} onClick={() => GenerateReport("ManualList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"> Manual List</Button>
                                                <Button style={{ marginLeft: "10px" }} onClick={() => GenerateReport("DeletedList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"> Deleted List</Button>
                                            </div>
                                            <div className="ReportButton">
                                                <Button onClick={() => GenerateReport("VehicleTareDetailsList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Transaction Vehicle Tare Details List</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByDate" && item.id === "ByDate" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByPayment" && item.id === "ByPayment" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySite" && item.id === "BySite" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sites", "Active Sites", "Inactive Sites"]} value={activeSites} onChange={(e) => setActiveSites(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sites", "Active Sites", "Inactive Sites"]} value={activeSitesSum} onChange={(e) => setActiveSitesSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByCustomer" && item.id === "ByCustomer" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCust} onChange={(e) => setActiveCust(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCustSum} onChange={(e) => setActiveCustSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCustCust} onChange={(e) => setActiveCustCust(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeCustProd} onChange={(e) => setActiveCustProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByProductCustomerSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Product</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySupplier" && item.id === "BySupplier" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Suppliers", "Active Suppliers", "Inactive Suppliers"]} value={activeSupp} onChange={(e) => setActiveSupp(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Suppliers", "Active Suppliers", "Inactive Suppliers"]} value={activeSuppSum} onChange={(e) => setActiveSuppSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByWasteStream" && item.id === "ByWasteStream" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Waste Streams", "Active  Waste Streams", "Inactive  Waste Streams"]} value={activeCat} onChange={(e) => setActiveCat(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Waste Streams", "Active  Waste Streams", "Inactive  Waste Streams"]} value={activeCatSum} onChange={(e) => setActiveCatSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySource" && item.id === "BySource" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sources", "Active Sources", "Inactive Sources"]} value={activeSrc} onChange={(e) => setActiveSrc(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sources", "Active Sources", "Inactive Sources"]} value={activeSrcSum} onChange={(e) => setActiveSrcSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByDestination" && item.id === "ByDestination" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activeDest} onChange={(e) => setActiveDest(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activeDestSum} onChange={(e) => setActiveDestSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByProduct" && item.id === "ByProduct" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeProd} onChange={(e) => setActiveProd(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeProdSum} onChange={(e) => setActiveProdSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activePDest} onChange={(e) => setActivePDest(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activePProd} onChange={(e) => setActivePProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByDestinationByProductSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary By Destination {item.report}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByCountedProduct" && item.id === "ByCountedProduct" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Counted Items", "Active Counted Items", "Inactive Counted Items"]} value={activeCount} onChange={(e) => setActiveCounted(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Counted Items", "Active Counted Items", "Inactive Counted Items"]} value={activeCountedSum} onChange={(e) => setActiveCountedSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByTruckConfiguration" && item.id === "ByTruckConfiguration" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByVehicleType" && item.id === "ByVehicleType" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Vehicle Types", "Active Vehicle Types", "Inactive Vehicle Types"]} value={activeType} onChange={(e) => setActiveType(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Vehicle Types", "Active Vehicle Types", "Inactive Vehicle Types"]} value={activeTypeSum} onChange={(e) => setActiveTypeSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByVehicle" && item.id === "ByVehicle" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByJob" && item.id === "ByJob" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJob} onChange={(e) => setActiveJob(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJobSum} onChange={(e) => setActiveJobSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJJobs} onChange={(e) => setActiveJJobs(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeJProd} onChange={(e) => setActiveJProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByProductJobSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Product Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeMJobs} onChange={(e) => setActiveMJobs(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByJobByLoad")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} MaxLoad Report</Button>                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByOperator" && item.id === "ByOperator" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Operators", "Active Operators", "Inactive Operators"]} value={activeUser} onChange={(e) => setActiveUser(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Operators", "Active Operators", "Inactive Operators"]} value={activeUserSum} onChange={(e) => setActiveUserSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByOverweight" && item.id === "ByOverweight" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeOJob} onChange={(e) => setActiveOJob(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Job")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Job Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                        </ExpansionPanel>

                    ))}
                </div>}
            </div>}
            {reportName && <div className="report-preview">
                <div className="report-preview__actions">
                    <Button type="button" onClick={Restart} themeColor="primary">
                        <i className="fa-solid fa-arrow-left" aria-hidden="true" /> Back to list
                    </Button>
                </div>
                <ReportViewer name={reportName} sites={siteValue} dateRange={dateRange} company={company} address={address} url={url} token={token} loadTypes={loadTypeValue}
                    payments={paymentValue} directions={directionValue} vehicles={vehicleValue} chargeTypes={chargeValue}
                    customers={customersValue} products={productsValue} jobs={jobsValue} trucks={trucksValue} categories={categoryValues} sources={sourcesValue} destinations={destinationsValue}
                    users={usersValue} vehicleConfigurations={vcsValue}
                ></ReportViewer></div>}
            {dialogError !== "" && <Dialog title="No Records" onClose={() => setDialogError("")}>
                <div>{dialogError}</div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => setDialogError("")}>Ok</button>
                </DialogActionsBar>
            </Dialog>}

        </div>
    );

}

export default SimpleReports;
